// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"d357831a","644":"c4c269d0","956":"c58c0c49"}[chunkId] + ".chunk.js";
};